import { h, Host, } from "@stencil/core";
import { requiredLabel, formMessageLogic, formTooltipLogic, } from "../../common/form";
import { formClasses } from "../../common/classesNames";
import { commonClassesNames } from "../../common/classesNames";
import state from "../store";
import { exportParts } from "../../common/export-parts";
export class GxgFormText {
    constructor() {
        this.hideTooltip = false;
        this.toolTip = false;
        this.clearButton = false;
        this.debounce = false;
        this.debounceDelay = 800;
        this.disabled = false;
        this.readonly = false;
        this.icon = null;
        this.cursorEnd = false;
        this.iconPosition = null;
        this.label = undefined;
        this.labelPosition = "start";
        this.borderless = false;
        this.minimal = false;
        this.overDarkBackground = false;
        this.placeholder = undefined;
        this.required = false;
        this.centerLabel = false;
        this.labelWidth = undefined;
        this.type = "text";
        this.multiple = false;
        this.fileList = undefined;
        this.acceptFile = undefined;
        this.preventValueChangedEmit = false;
        this.validationStatus = "indeterminate";
        this.validationMessage = undefined;
        this.informationMessage = undefined;
        this.value = undefined;
        this.maxWidth = "100%";
        this.width = "100%";
        this.textStyle = "regular";
        this.password = false;
        this.maxLength = undefined;
        this.minLength = undefined;
        this.cursorInside = false;
        this.inputSize = "auto";
        this.mouseCoordinates = {
            x: null,
            y: null,
        };
        this.rtl = false;
    }
    parts = {
        input: "input",
    };
    exportparts;
    el;
    textInput;
    fileInputEl;
    /*********************************
    PROPERTIES & STATE
    *********************************/
    timeoutReference;
    /**
     * Returns the input value
     */
    input;
    /**
     * Returns the input value
     */
    change;
    /**
     * The clear button was clicked
     */
    clearButtonClicked;
    /**
     * The clear button was clicked
     */
    valueChanged;
    /**
     * File Selected
     */
    fileSelected;
    watchValueHandler(newValue) {
        if (!this.preventValueChangedEmit && this.debounce) {
            clearTimeout(this.timeoutReference);
            this.timeoutReference = setTimeout(() => {
                this.valueChanged.emit(newValue);
            }, this.debounceDelay);
        }
        else if (!this.preventValueChangedEmit && !this.debounce) {
            this.valueChanged.emit(newValue);
        }
        if (this.minimal) {
            this.updateGhostSpan();
        }
        if (this.minimal) {
            this.updateGhostSpan();
        }
    }
    async selectInputText() {
        this.textInput.focus();
        this.textInput.select();
    }
    async openFile() {
        if (this.type === "file") {
            this.fileInputEl.click();
        }
    }
    async clearInput() {
        this.clearButtonFunc();
    }
    componentWillLoad() {
        this.evaluateIcon();
        this.attachExportParts();
        this.evaluateLabelAlignment();
    }
    attachExportParts = () => {
        const part = this.el.getAttribute("part");
        const exportPartsResult = exportParts(part, this.parts);
        exportPartsResult.length && (this.exportparts = exportPartsResult);
    };
    evaluateIcon = () => {
        if (this.type === "file") {
            this.icon = "controls/file-upload";
            this.iconPosition = "start";
            this.placeholder = this.placeholder || "Select a file";
        }
    };
    evaluateLabelAlignment = () => {
        if (this.labelPosition === "start") {
            this.centerLabel = true;
        }
    };
    /*********************************
    METHODS
    *********************************/
    iconPositionFunc() {
        if (this.iconPosition !== null && this.icon !== null) {
            return this.iconPosition;
        }
    }
    inputIcon() {
        const iconSize = this.iconSize();
        if (this.iconPosition !== null && this.icon !== null) {
            if (this.validationStatus === "warning") {
                return (h("gxg-icon", { class: "custom-icon", type: this.icon, size: iconSize, color: "warning" }));
            }
            if (this.validationStatus === "error") {
                return (h("gxg-icon", { class: "custom-icon", type: this.icon, size: iconSize, color: "error" }));
            }
            return (h("gxg-icon", { class: "custom-icon", type: this.icon, size: iconSize, color: this.disabled ? "disabled" : "auto" }));
        }
    }
    handleInput(e) {
        e.stopPropagation();
        const target = e.target;
        this.value = target.value;
        this.input.emit(target.value);
    }
    handleKeyDown = (e) => {
        if (e.key === "Enter" && this.type === "file") {
            this.textInput.click();
        }
    };
    handleChange(e) {
        e.stopPropagation();
        const target = e.target;
        this.value = target.value;
        this.change.emit(target.value);
    }
    onFocusHandler() {
        if (this.cursorEnd) {
            this.textInput.setSelectionRange(this.textInput.value.length, this.textInput.value.length);
        }
    }
    clearButtonFunc() {
        this.clearButtonClicked.emit({ prevValue: this.value });
        this.value = "";
        if (this.type === "file") {
            this.fileList = null;
            this.fileInputEl.value = "";
        }
    }
    updateGhostSpan() {
        if (this.minimal) {
            //Update ghost span content, and then get and apply the width from the ghost span
            const ghostSpan = this.el.shadowRoot.querySelector(".ghost-span");
            ghostSpan.innerHTML = this.value;
            //Then get the ghost span width
            const ghostSpanWidth = ghostSpan.offsetWidth + 5;
            const input = this.el.shadowRoot.querySelector(".input");
            //Finally set that width to the input!
            input.style.width = ghostSpanWidth + "px";
        }
    }
    mouseEnterHandler() {
        setTimeout(function () {
            const inputText = this.el.shadowRoot.querySelector(".input");
            //Contextual menu coordinates
            const inputTextArea = inputText.getBoundingClientRect();
            if (this.mouseCoordinates.x > inputTextArea.left &&
                this.mouseCoordinates.x < inputTextArea.right &&
                this.mouseCoordinates.y > inputTextArea.top &&
                this.mouseCoordinates.y < inputTextArea.bottom) {
                //Mouse pointer is inside the input text
                this.cursorInside = true;
            }
        }.bind(this), 500);
    }
    mouseOutHandler() {
        this.cursorInside = false;
    }
    mouseMoveHandler(e) {
        this.mouseCoordinates["x"] = e.clientX;
        this.mouseCoordinates["y"] = e.clientY;
    }
    componentDidLoad() {
        if (this.minimal) {
            document.addEventListener("mousemove", this.mouseMoveHandler.bind(this));
            /**************
            GHOST SPAN
            Ghost span for the "minimal" type input, in order to make the input width fit the content
            **************/
            const intersectionObserver = new IntersectionObserver(function (entries) {
                // If intersectionRatio is 0, the target is out of view
                // and we do not need to do anything.
                if (entries[0].intersectionRatio <= 0)
                    return;
                const input = this.el.shadowRoot.querySelector(".input");
                const inputComputedStyles = window.getComputedStyle(input);
                const ghostSpan = this.el.shadowRoot.querySelector(".ghost-span");
                //Set ghostSpan outside of the visible area
                ghostSpan.style.position = "fixed";
                ghostSpan.style.left = "-1000px";
                ghostSpan.style.top = "-1000px";
                ghostSpan.style.zIndex = "-1000";
                ghostSpan.style.opacity = "0";
                //Set input styles that affect the width to the ghost span
                ghostSpan.style.fontSize = inputComputedStyles.fontSize;
                ghostSpan.style.fontFamily = inputComputedStyles.fontFamily;
                ghostSpan.style.textTransform = inputComputedStyles.textTransform;
                ghostSpan.style.display = "inline-block";
                ghostSpan.style.paddingLeft = inputComputedStyles.paddingRight;
                ghostSpan.style.paddingRight = inputComputedStyles.paddingRight;
                ghostSpan.style.letterSpacing = inputComputedStyles.letterSpacing;
                ghostSpan.style.fontWeight = inputComputedStyles.fontWeight;
                //Then get the ghost span width
                const ghostSpanWidth = ghostSpan.offsetWidth + 5;
                input.style.width = "0px";
                //get inner-wrapper width
                const innerWrapperWidth = this.el.shadowRoot.querySelector(".inner-wrapper")
                    .offsetWidth - 5;
                //Finally set that width to the input!
                input.style.width = ghostSpanWidth + "px";
                input.style.maxWidth = innerWrapperWidth + "px";
                //Listen to resizeObserver to set the new max-width value on the on the input
                const resizeObserver = new ResizeObserver(() => {
                    input.style.width = "0px";
                    const innerWrapperWidth = this.el.shadowRoot.querySelector(".inner-wrapper").offsetWidth - 5;
                    input.style.maxWidth = innerWrapperWidth + "px";
                    input.style.width = ghostSpanWidth + "px";
                });
                const innerWrapper = this.el.shadowRoot.querySelector(".inner-wrapper");
                resizeObserver.observe(innerWrapper);
            }.bind(this));
            // start observing
            intersectionObserver.observe(this.el.shadowRoot.querySelector(".input"));
        } // if (this.minimal)
        //Reading Direction
        const dirHtml = document
            .getElementsByTagName("html")[0]
            .getAttribute("dir");
        const dirBody = document
            .getElementsByTagName("body")[0]
            .getAttribute("dir");
        if (dirHtml === "rtl" || dirBody === "rtl") {
            this.rtl = true;
        }
    }
    disconnectedCallback() {
        if (this.minimal) {
            document.removeEventListener("mousemove", this.mouseMoveHandler);
        }
    }
    iconSize() {
        if (state.large) {
            return "regular";
        }
        else {
            return "small";
        }
    }
    evaluateType() {
        if (this.password) {
            return "password";
        }
        else {
            return "text";
        }
    }
    inputFileChangedHandler = (e) => {
        const selectedFiles = e.target.files;
        this.fileList = selectedFiles;
        this.fileSelected.emit(selectedFiles);
        if (selectedFiles.length > 1) {
            this.value = `${selectedFiles.length} files chosen`;
        }
        else {
            this.value = selectedFiles[0].name;
        }
    };
    renderInputFile = () => {
        if (this.type === "file") {
            return (h("input", { class: "input-file", type: "file", multiple: this.multiple, accept: this.acceptFile, ref: (el) => (this.fileInputEl = el), onChange: this.inputFileChangedHandler, style: { display: "none" } }));
        }
    };
    render() {
        return (h(Host, { role: "textbox", "aria-label": this.label, "icon-position": this.iconPositionFunc(), style: {
                width: this.width,
                maxWidth: this.maxWidth,
            }, class: {
                rtl: this.rtl,
                large: state.large,
                mercury: state.mercury,
                borderless: this.borderless,
                file: this.type === "file",
                tooltip: this.toolTip,
                "has-icon": this.icon,
                [formClasses["VALIDATION_INDETERMINATE_CLASS"]]: this.validationStatus === "indeterminate",
                [formClasses["VALIDATION_WARNING_CLASS"]]: this.validationStatus === "warning",
                [formClasses["VALIDATION_ERROR_CLASS"]]: this.validationStatus === "error",
                [formClasses["VALIDATION_SUCCESS_CLASS"]]: this.validationStatus === "success",
                [commonClassesNames["DISABLED_CLASS"]]: this.disabled,
            }, exportParts: this.exportparts ? this.exportparts : null }, this.minimal ? h("span", { class: "ghost-span" }, this.value) : null, h("div", { class: {
                "outer-wrapper": true,
            } }, this.label ? (h("gxg-label", { labelPosition: this.labelPosition, center: this.centerLabel, width: this.labelWidth }, this.label, requiredLabel(this))) : (""), h("div", { class: {
                "inner-wrapper": true,
                "clear-button": this.clearButton === true,
            } }, h("input", { part: this.parts.input, type: this.evaluateType(), value: this.value, class: {
                input: true,
                "form-element": true,
                "form-element--readonly": this.readonly,
                "cursor-inside": this.cursorInside,
                "clear-button": this.clearButton === true,
                "custom-icon": this.icon,
                "custom-icon--end": this.iconPosition === "end",
                "input--borderless": this.borderless,
            }, placeholder: this.placeholder, disabled: this.disabled, readonly: "readonly" ? this.readonly : null, onClick: this.type === "file" && this.readonly && this.openFile, onInput: this.handleInput.bind(this), onKeyDown: this.handleKeyDown, onChange: this.handleChange.bind(this), onFocus: this.onFocusHandler.bind(this), required: this.required, onMouseEnter: this.mouseEnterHandler.bind(this), onMouseOut: this.mouseOutHandler.bind(this), ref: (el) => (this.textInput = el), maxLength: this.maxLength ? parseInt(this.maxLength) : null, minLength: this.minLength ? parseInt(this.minLength) : null }), this.inputIcon(), this.clearButton ? (h("gxg-icon", { class: "clear-button", type: "gemini-tools/close", size: this.iconSize(), color: "onbackground", onClick: this.clearButtonFunc.bind(this) })) : null, this.toolTip ? formTooltipLogic(this, this.hideTooltip) : null, this.labelPosition === "start" && !this.toolTip
            ? formMessageLogic(this)
            : null, this.renderInputFile())), this.labelPosition === "above" && !this.toolTip
            ? formMessageLogic(this)
            : null));
    }
    static get is() { return "gxg-form-text"; }
    static get encapsulation() { return "shadow"; }
    static get delegatesFocus() { return true; }
    static get originalStyleUrls() {
        return {
            "$": ["form-text.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["form-text.css"]
        };
    }
    static get properties() {
        return {
            "hideTooltip": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute disables the tooltip. Useful for the combo-box."
                },
                "attribute": "hide-tooltip",
                "reflect": false,
                "defaultValue": "false"
            },
            "toolTip": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute displays a tooltip message, instead of a block message below the control"
                },
                "attribute": "tool-tip",
                "reflect": false,
                "defaultValue": "false"
            },
            "clearButton": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute displays a clear (cross) button-icon on the right side"
                },
                "attribute": "clear-button",
                "reflect": true,
                "defaultValue": "false"
            },
            "debounce": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute activates a debounce for the valueChanged event. This will cause the event to be emitted after 'debounceDelay' time."
                },
                "attribute": "debounce",
                "reflect": false,
                "defaultValue": "false"
            },
            "debounceDelay": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The debounce delay value. Only applies if 'debounce' is true."
                },
                "attribute": "debounce-delay",
                "reflect": false,
                "defaultValue": "800"
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute makes the input disabled"
                },
                "attribute": "disabled",
                "reflect": false,
                "defaultValue": "false"
            },
            "readonly": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute makes the input readonly"
                },
                "attribute": "readonly",
                "reflect": false,
                "defaultValue": "false"
            },
            "icon": {
                "type": "any",
                "mutable": false,
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The input icon (optional)"
                },
                "attribute": "icon",
                "reflect": false,
                "defaultValue": "null"
            },
            "cursorEnd": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If true, it will position the cursor at the end when the input is focused."
                },
                "attribute": "cursor-end",
                "reflect": false,
                "defaultValue": "false"
            },
            "iconPosition": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "IconPosition",
                    "resolved": "\"end\" | \"start\"",
                    "references": {
                        "IconPosition": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/form-text/form-text.tsx",
                            "id": "src/components/form-text/form-text.tsx::IconPosition"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The input icon side"
                },
                "attribute": "icon-position",
                "reflect": true,
                "defaultValue": "null"
            },
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The input label"
                },
                "attribute": "label",
                "reflect": false
            },
            "labelPosition": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "LabelPosition",
                    "resolved": "\"above\" | \"start\"",
                    "references": {
                        "LabelPosition": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/form-text/form-text.tsx",
                            "id": "src/components/form-text/form-text.tsx::LabelPosition"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The label position"
                },
                "attribute": "label-position",
                "reflect": true,
                "defaultValue": "\"start\""
            },
            "borderless": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute hides the border."
                },
                "attribute": "borderless",
                "reflect": false,
                "defaultValue": "false"
            },
            "minimal": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute hides the border, and sets the background to transparent when the element has no focus"
                },
                "attribute": "minimal",
                "reflect": true,
                "defaultValue": "false"
            },
            "overDarkBackground": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute sets the text color to white. Usefull when \"minimal\" attribute is applied and the background behind the input is dark"
                },
                "attribute": "over-dark-background",
                "reflect": true,
                "defaultValue": "false"
            },
            "placeholder": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The input placeholder"
                },
                "attribute": "placeholder",
                "reflect": false
            },
            "required": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute makes this input required"
                },
                "attribute": "required",
                "reflect": true,
                "defaultValue": "false"
            },
            "centerLabel": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Centers the label"
                },
                "attribute": "center-label",
                "reflect": false,
                "defaultValue": "false"
            },
            "labelWidth": {
                "type": "any",
                "mutable": false,
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The label width"
                },
                "attribute": "label-width",
                "reflect": false
            },
            "type": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "InputType",
                    "resolved": "\"file\" | \"password\" | \"text\"",
                    "references": {
                        "InputType": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/form-text/form-text.tsx",
                            "id": "src/components/form-text/form-text.tsx::InputType"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The type of input"
                },
                "attribute": "type",
                "reflect": false,
                "defaultValue": "\"text\""
            },
            "multiple": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Allows multiple files if type is \"file\""
                },
                "attribute": "multiple",
                "reflect": false,
                "defaultValue": "false"
            },
            "fileList": {
                "type": "unknown",
                "mutable": true,
                "complexType": {
                    "original": "FileList",
                    "resolved": "FileList",
                    "references": {
                        "FileList": {
                            "location": "global",
                            "id": "global::FileList"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The file list that the user selected (only applies if the input type is \"file\")"
                }
            },
            "acceptFile": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The type of files the input accepts"
                },
                "attribute": "accept-file",
                "reflect": false
            },
            "preventValueChangedEmit": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Prevent \"valueChanged\" event from being emitted (helpful for cases where the event causes a conflict )"
                },
                "attribute": "prevent-value-changed-emit",
                "reflect": false,
                "defaultValue": "false"
            },
            "validationStatus": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "ValidationStatus",
                    "resolved": "\"error\" | \"indeterminate\" | \"success\" | \"warning\"",
                    "references": {
                        "ValidationStatus": {
                            "location": "import",
                            "path": "../../common/types",
                            "id": "src/common/types.ts::ValidationStatus"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The validation status"
                },
                "attribute": "validation-status",
                "reflect": false,
                "defaultValue": "\"indeterminate\""
            },
            "validationMessage": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The message to display when validation fails (error)"
                },
                "attribute": "validation-message",
                "reflect": false
            },
            "informationMessage": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "An informative message to help the user filling the information"
                },
                "attribute": "information-message",
                "reflect": false
            },
            "value": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The input value"
                },
                "attribute": "value",
                "reflect": true
            },
            "maxWidth": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The input max. width"
                },
                "attribute": "max-width",
                "reflect": false,
                "defaultValue": "\"100%\""
            },
            "width": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The input width"
                },
                "attribute": "width",
                "reflect": false,
                "defaultValue": "\"100%\""
            },
            "textStyle": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "Style",
                    "resolved": "\"quote\" | \"regular\" | \"title-01\" | \"title-02\" | \"title-03\" | \"title-04\" | \"title-05\"",
                    "references": {
                        "Style": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/form-text/form-text.tsx",
                            "id": "src/components/form-text/form-text.tsx::Style"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The text style"
                },
                "attribute": "text-style",
                "reflect": true,
                "defaultValue": "\"regular\""
            },
            "password": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute sets the input type as password"
                },
                "attribute": "password",
                "reflect": false,
                "defaultValue": "false"
            },
            "maxLength": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The input max. length"
                },
                "attribute": "max-length",
                "reflect": false,
                "defaultValue": "undefined"
            },
            "minLength": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The input min. length"
                },
                "attribute": "min-length",
                "reflect": false,
                "defaultValue": "undefined"
            }
        };
    }
    static get states() {
        return {
            "cursorInside": {},
            "inputSize": {},
            "mouseCoordinates": {},
            "rtl": {}
        };
    }
    static get events() {
        return [{
                "method": "input",
                "name": "input",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Returns the input value"
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }, {
                "method": "change",
                "name": "change",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Returns the input value"
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }, {
                "method": "clearButtonClicked",
                "name": "clearButtonClicked",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "The clear button was clicked"
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }, {
                "method": "valueChanged",
                "name": "valueChanged",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "The clear button was clicked"
                },
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                }
            }, {
                "method": "fileSelected",
                "name": "fileSelected",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "File Selected"
                },
                "complexType": {
                    "original": "FileList",
                    "resolved": "FileList",
                    "references": {
                        "FileList": {
                            "location": "global",
                            "id": "global::FileList"
                        }
                    }
                }
            }];
    }
    static get methods() {
        return {
            "selectInputText": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            },
            "openFile": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            },
            "clearInput": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            }
        };
    }
    static get elementRef() { return "el"; }
    static get watchers() {
        return [{
                "propName": "value",
                "methodName": "watchValueHandler"
            }];
    }
}
//# sourceMappingURL=form-text.js.map
